// ==========================
// Version 2 — thirdwebClient.js (thirdweb v5 client)
// ==========================
import { createThirdwebClient } from "thirdweb";

const THIRDWEB_CLIENT_ID = process.env.REACT_APP_THIRDWEB_CLIENT_ID;

if (!THIRDWEB_CLIENT_ID) {
  // eslint-disable-next-line no-console
  console.error(
    "[BWK][Thirdweb] Missing REACT_APP_THIRDWEB_CLIENT_ID in .env.local. " +
      "Wallet connect & contract calls will not work."
  );
}

export const thirdwebClient = createThirdwebClient({
  clientId: THIRDWEB_CLIENT_ID,
});

// ==========================
// End Version 2 — thirdwebClient.js
// ==========================
